export default __webpack_public_path__ + "locales/sq-AL/ConnectDialog.json?hash=01449c6c4674282a1e6cff7a44094985";